import { createActions } from '@manager-base/app-base/config/data-access';

export function FeePolicySettingsApi(
    BUILDING_TYPE,
    BASE_PATH_APP
) {
    const service = createActions({});
    service.getFeePolicySettingsUrl = function getFeePolicySettingsUrl(buildingTypeId, entityId) {
        return buildingTypeId === BUILDING_TYPE.Rental
            ? `${BASE_PATH_APP}/properties/${entityId}/financials/lease-payment-settings`
            : `${BASE_PATH_APP}/associations/${entityId}/financials/account-payment-settings`;
    };
    return service;
}
FeePolicySettingsApi.$inject = [
    'BUILDING_TYPE',
    'BASE_PATH_APP'
];
